import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "accordionId", "className", "children", "multiple", "style", "onClick", "onChange", "activeKeys", "defaultActivekeys", "showExpandIcon"];
import * as React from 'react';
import ClassNames from 'classnames';
import { useControlled, mergeRefs } from '../utils';
var Accordion = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    accordionId = _ref.accordionId,
    className = _ref.className,
    children = _ref.children,
    multiple = _ref.multiple,
    style = _ref.style,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    activeKeysProp = _ref.activeKeys,
    defaultActivekeys = _ref.defaultActivekeys,
    _ref$showExpandIcon = _ref.showExpandIcon,
    showExpandIcon = _ref$showExpandIcon === void 0 ? true : _ref$showExpandIcon,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useControlled = useControlled(activeKeysProp, defaultActivekeys || []),
    activeKeys = _useControlled[0],
    setActiveKeys = _useControlled[1],
    isControlled = _useControlled[2];
  var accordionRef = React.useRef(null);
  var classes = ClassNames('ap-accordion-group-container', className);
  React.useEffect(function () {
    if (!multiple && activeKeys.length > 1) {
      var temp = activeKeys.slice(0, 1);
      updateKeys([].concat(temp), null);
    }
  }, [multiple, activeKeys]);
  var handleItemClick = React.useCallback(function (e, keyValue) {
    var _collapsed = activeKeys.includes(keyValue);
    var newActivekkeys = activeKeys;
    if (multiple) {
      newActivekkeys = _collapsed ? activeKeys.filter(function (data) {
        return data !== keyValue;
      }) : activeKeys.concat(keyValue);
    } else {
      newActivekkeys = _collapsed ? [] : [keyValue];
    }
    updateKeys(newActivekkeys, e);
  }, [activeKeys, multiple, onClick, onChange]);
  var content = React.useCallback(function () {
    return React.Children.map(children, function (child, index) {
      var keyValue = child.props.itemKey;
      return /*#__PURE__*/React.cloneElement(child, {
        expanded: activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.includes(keyValue),
        onClickEvent: handleItemClick,
        showExpandIcon: child.props.showExpandIcon !== undefined ? child.props.showExpandIcon : showExpandIcon,
        accordionId: accordionId,
        accordionRef: accordionRef
      });
    });
  }, [children, activeKeys]);
  var updateKeys = function updateKeys(newKeys, event) {
    setActiveKeys(newKeys);
    onClick && onClick(newKeys, event);
    onChange && onChange(newKeys, event);
  };
  return /*#__PURE__*/React.createElement("ul", _extends({
    id: id || accordionId,
    style: style,
    className: classes,
    ref: mergeRefs(ref, accordionRef),
    role: "tablist",
    "aria-multiselectable": multiple
  }, otherProps), content());
});
Accordion.displayName = 'Accordion';
export default Accordion;